import { useContext } from 'react';

import RegistrationFormContext, { RegistrationFormValues } from './context';

const useRegistrationForm = (): RegistrationFormValues => useContext(RegistrationFormContext);

export default useRegistrationForm;
